<template>
  <card title="视频监控">
    <div class="card_content box_style">
      <div class="item_list fb" v-if="videoListData.length > 0">
        <div class="item fs" v-for="(item, index) in videoListData" :key="index">
          <div class="xg_flv_jiankong" @click="handleClickVideo(item)"></div>
        </div>
      </div>
      <div class="item_list fb" v-else>
        <div class="item fs item_loading" v-for="(item, index) in loadingItem" :key="index">
          <p>视频流加载中</p>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from '@/components/Card.vue';
import Player from 'xgplayer';
import FlvPlugin from 'xgplayer-flv';
import 'xgplayer/dist/index.min.css';
import * as Api from '@/api';
import { BASE_IP_URL } from '@/globalConfig';

export default {
  name: 'ShiPinJianKong',
  components: {
    Card,
  },
  data() {
    return {
      videoListData: [],
      loadingItem: [1, 2, 3],
    };
  },
  mounted() {
    Api.getHikFlvByStationCode().then((res) => {
      if (res.success) {
        const { records } = res.data;
        // this.videoListData = records.slice(9, 12);
        this.videoListData = [records[0], records[13], records[9]];
        this.renderVideoBox();
        this.$Storage.set('videoListStorage', records);
      }
    });
  },
  methods: {
    handleClickVideo(video) {
      this.$bus.$emit('curVideoSrc', video.liveSourceAddress);
      this.$bus.$emit('showVideoModal', true);
    },
    renderVideoBox() {
      const that = this;
      this.$nextTick(() => {
        let videoEl = document.querySelectorAll('.xg_flv_jiankong');
        console.log('videoEl :>> ', videoEl);
        for (let i = 0; i < this.videoListData.length; i++) {
          var player = new Player({
            // id: 'xgFlv',
            el: videoEl[i],
            url: that.videoListData[i].liveSourceAddress.replace(
              'http://223.214.6.181:8950/openUrl/',
              // '172.30.100.204:8950'
              BASE_IP_URL
            ),
            volume: 0,
            playsinline: true,
            poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/2.20ed85c7.jpg',
            autoplay: true,
            width: 460,
            height: 220,
            plugins: [FlvPlugin],
            isLive: true,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card_content {
  height: 715px;
  padding: 0 9px;
  .item_list {
    flex-wrap: wrap;
    .item {
      // width: 224px;
      // height: 126px;
      width: 460px;
      height: 218px;
      border: 1px solid rgba(79, 158, 253, 0.4);
      margin-top: 14px;
      cursor: pointer;
      &.item_loading {
        p {
          margin: auto;
        }
      }
    }
  }
}
</style>
